/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AmadeusSyncRequestBuilderRequestsMetadata, type AmadeusSyncRequestBuilder } from './amadeusSync/index.js';
// @ts-ignore
import { GetAllotmentsForAmadeusRequestBuilderRequestsMetadata, type GetAllotmentsForAmadeusRequestBuilder } from './getAllotmentsForAmadeus/index.js';
// @ts-ignore
import { MonitorPassengerDataFilesRequestBuilderRequestsMetadata, type MonitorPassengerDataFilesRequestBuilder } from './monitorPassengerDataFiles/index.js';
// @ts-ignore
import { NetlineSyncRequestBuilderRequestsMetadata, type NetlineSyncRequestBuilder } from './netlineSync/index.js';
// @ts-ignore
import { ProcessInvoicesRequestBuilderRequestsMetadata, type ProcessInvoicesRequestBuilder } from './processInvoices/index.js';
// @ts-ignore
import { ProcessNewBlobsRequestBuilderRequestsMetadata, type ProcessNewBlobsRequestBuilder } from './processNewBlobs/index.js';
// @ts-ignore
import { ProcessPassengerDataFilesRequestBuilderRequestsMetadata, type ProcessPassengerDataFilesRequestBuilder } from './processPassengerDataFiles/index.js';
// @ts-ignore
import { ProcessUpgradesRequestBuilderRequestsMetadata, type ProcessUpgradesRequestBuilder } from './processUpgrades/index.js';
// @ts-ignore
import { RetryPassengerDataFilesRequestBuilderRequestsMetadata, type RetryPassengerDataFilesRequestBuilder } from './retryPassengerDataFiles/index.js';
// @ts-ignore
import { type UpdateRequestsRequestBuilder, UpdateRequestsRequestBuilderRequestsMetadata } from './updateRequests/index.js';
// @ts-ignore
import { type VerifyLatestDashboardBookingsRequestBuilder, VerifyLatestDashboardBookingsRequestBuilderRequestsMetadata } from './verifyLatestDashboardBookings/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Task
 */
export interface TaskRequestBuilder extends BaseRequestBuilder<TaskRequestBuilder> {
    /**
     * The AmadeusSync property
     */
    get amadeusSync(): AmadeusSyncRequestBuilder;
    /**
     * The GetAllotmentsForAmadeus property
     */
    get getAllotmentsForAmadeus(): GetAllotmentsForAmadeusRequestBuilder;
    /**
     * The MonitorPassengerDataFiles property
     */
    get monitorPassengerDataFiles(): MonitorPassengerDataFilesRequestBuilder;
    /**
     * The NetlineSync property
     */
    get netlineSync(): NetlineSyncRequestBuilder;
    /**
     * The ProcessInvoices property
     */
    get processInvoices(): ProcessInvoicesRequestBuilder;
    /**
     * The ProcessNewBlobs property
     */
    get processNewBlobs(): ProcessNewBlobsRequestBuilder;
    /**
     * The ProcessPassengerDataFiles property
     */
    get processPassengerDataFiles(): ProcessPassengerDataFilesRequestBuilder;
    /**
     * The ProcessUpgrades property
     */
    get processUpgrades(): ProcessUpgradesRequestBuilder;
    /**
     * The RetryPassengerDataFiles property
     */
    get retryPassengerDataFiles(): RetryPassengerDataFilesRequestBuilder;
    /**
     * The UpdateRequests property
     */
    get updateRequests(): UpdateRequestsRequestBuilder;
    /**
     * The VerifyLatestDashboardBookings property
     */
    get verifyLatestDashboardBookings(): VerifyLatestDashboardBookingsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const TaskRequestBuilderUriTemplate = "{+baseurl}/Task";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const TaskRequestBuilderNavigationMetadata: Record<Exclude<keyof TaskRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    amadeusSync: {
        requestsMetadata: AmadeusSyncRequestBuilderRequestsMetadata,
    },
    getAllotmentsForAmadeus: {
        requestsMetadata: GetAllotmentsForAmadeusRequestBuilderRequestsMetadata,
    },
    monitorPassengerDataFiles: {
        requestsMetadata: MonitorPassengerDataFilesRequestBuilderRequestsMetadata,
    },
    netlineSync: {
        requestsMetadata: NetlineSyncRequestBuilderRequestsMetadata,
    },
    processInvoices: {
        requestsMetadata: ProcessInvoicesRequestBuilderRequestsMetadata,
    },
    processNewBlobs: {
        requestsMetadata: ProcessNewBlobsRequestBuilderRequestsMetadata,
    },
    processPassengerDataFiles: {
        requestsMetadata: ProcessPassengerDataFilesRequestBuilderRequestsMetadata,
    },
    processUpgrades: {
        requestsMetadata: ProcessUpgradesRequestBuilderRequestsMetadata,
    },
    retryPassengerDataFiles: {
        requestsMetadata: RetryPassengerDataFilesRequestBuilderRequestsMetadata,
    },
    updateRequests: {
        requestsMetadata: UpdateRequestsRequestBuilderRequestsMetadata,
    },
    verifyLatestDashboardBookings: {
        requestsMetadata: VerifyLatestDashboardBookingsRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
